"use strict";

var _interopRequireWildcard = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _user = require("@/api/user");

var _auth = require("@/utils/auth");

var _router = _interopRequireWildcard(require("@/router"));

var _fingerprintjs = _interopRequireDefault(require("@fingerprintjs/fingerprintjs"));

var state = {
  token: (0, _auth.getToken)(),
  fingerprint: "",
  name: "",
  avatar: "",
  introduction: "",
  accounts: {},
  permissions: null,
  roles: [],
  isForced: false,
  netwayCodeEnums: (0, _auth.getNetwayCodeEnums)()
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_ACCOUNT: function SET_ACCOUNT(state, account) {
    state.accounts = account;
  },
  SET_PERMISSION: function SET_PERMISSION(state, permissions) {
    state.permissions = permissions;
  },
  SET_BIND_GOOGLE_VERIFICATION: function SET_BIND_GOOGLE_VERIFICATION(state, isForced) {
    state.isForced = isForced;
  },
  SET_FINGERPRINT: function SET_FINGERPRINT(state, fingerprint) {
    state.fingerprint = fingerprint;
  }
};
var getters = {
  hasPermission: function hasPermission(state) {
    return function (permission) {
      if (state.permissions[0]) {
        return state.permissions[0].includes(permission);
      }

      return false;
    };
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    return new Promise(function (resolve, reject) {
      (0, _user.login)(userInfo).then(
      /*#__PURE__*/
      function () {
        var _ref2 = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(response) {
          var data, msg, code;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  data = response.data, msg = response.msg, code = response.code;

                  if (!(code === 200)) {
                    _context.next = 8;
                    break;
                  }

                  commit("SET_TOKEN", data.token.token);
                  _context.next = 5;
                  return (0, _auth.setToken)(data.token.token);

                case 5:
                  resolve();
                  _context.next = 9;
                  break;

                case 8:
                  reject(msg);

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;
    return new Promise(function (resolve, reject) {
      (0, _user.getInfo)().then(
      /*#__PURE__*/
      function () {
        var _ref4 = (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee2(response) {
          var _response$data, roles, account, permissions, isForcedBindGoogle, fingerprint;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _response$data = response.data, roles = _response$data.roles, account = _response$data.account, permissions = _response$data.permissions, isForcedBindGoogle = _response$data.isForcedBindGoogle;
                  commit("SET_ROLES", roles);
                  commit("SET_NAME", account.userName);
                  commit("SET_ACCOUNT", account);
                  commit("SET_PERMISSION", permissions);
                  commit('SET_BIND_GOOGLE_VERIFICATION', isForcedBindGoogle);
                  _context2.next = 8;
                  return (0, _auth.generateFingerprint)();

                case 8:
                  fingerprint = _context2.sent;
                  commit('SET_FINGERPRINT', fingerprint);
                  resolve(response.data);

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref4.apply(this, arguments);
        };
      }()).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref5, payload) {
    var commit = _ref5.commit;
    return new Promise(
    /*#__PURE__*/
    function () {
      var _ref6 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(resolve, reject) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _user.logout)();

              case 2:
                commit("SET_TOKEN", "");
                commit("SET_ACCOUNT", null);
                commit("SET_PERMISSION", []);
                commit("SET_ROLES", []);
                commit('SET_BIND_GOOGLE_VERIFICATION', false);
                (0, _auth.removeToken)();
                (0, _router.resetRouter)();
                resolve();

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3, _x4) {
        return _ref6.apply(this, arguments);
      };
    }());
  },
  // remove token
  resetToken: function resetToken(_ref7) {
    var commit = _ref7.commit;
    return new Promise(function (resolve) {
      commit("SET_TOKEN", "");
      commit("SET_ACCOUNT", {});
      commit("SET_PERMISSION", []);
      commit("SET_ROLES", []);
      commit('SET_BIND_GOOGLE_VERIFICATION', false);
      (0, _auth.removeToken)();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref8, role) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;
    return new Promise(
    /*#__PURE__*/
    function () {
      var _ref9 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4(resolve) {
        var token, _ref10, roles, accessRoutes;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                token = role + "-token";
                commit("SET_TOKEN", token);
                (0, _auth.setToken)(token);
                _context4.next = 5;
                return dispatch("getInfo");

              case 5:
                _ref10 = _context4.sent;
                roles = _ref10.roles;
                (0, _router.resetRouter)(); // generate accessible routes map based on roles

                _context4.next = 10;
                return dispatch("permission/generateRoutes", roles, {
                  root: true
                });

              case 10:
                accessRoutes = _context4.sent;

                // dynamically add accessible routes
                _router.default.addRoutes(accessRoutes); // reset visited views and cached views


                dispatch("tagsView/delAllViews", null, {
                  root: true
                });
                resolve();

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x5) {
        return _ref9.apply(this, arguments);
      };
    }());
  }
};
var _default = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};
exports.default = _default;